import { useRelatedProducts } from '../hooks/useRelatedProducts';

const Title = () => {
	const {
		blockClass,
		productList: { titleText },
	} = useRelatedProducts();

	const renderClass = () => blockClass && `vtex-shelf-1-x-title--${blockClass}`;

	return (
		<div
			className={`vtex-shelf-1-x-title ${renderClass()} t-heading-2 fw3 w-100 flex justify-center pt7 pb6 c-muted-1`}
		>
			{titleText}
		</div>
	);
};

export default Title;
